<template>
  <el-container>
    <el-header>
    <div :style="'top: 0px;height: 50px;width: '+btn_region_w+';position: fixed;z-index: 100;background: #f5f5f5;'">
      <div style="margin: 6px 10px 6px 38px;">
        <el-button v-if="isShowStartBtn" type="primary" @click="start" :disabled="disabled" v-preventReClick>启动</el-button>
        <el-button type="defult" @click="saveDraft" :disabled="disabled">保存</el-button>
        <el-button type="defult" @click="back">关闭</el-button>
        <el-button type="danger" @click="deleteBtm" v-if="instId">删除</el-button>
        <span style="float: right;margin-top:-10px">
          <h3 style="text-align:left">
            <!-- 流程名称：{{defName}} -->
            <el-button type="text" icon="icon-flow1" @click="taskImage">流程图</el-button>
          </h3>
        </span>
      </div>
    </div>
    </el-header>
    <!-- <el-header  height="48px">
      <el-row style="margin-top: 20px;">
        <el-col :span="12" :offset="0" class="top-subject-col">
          <h3 style="text-align:left">流程名称：{{defName}}</h3>
        </el-col>
      </el-row>
    </el-header> -->
    <el-main>
      <el-card class="start-card" >
        <FormContent v-if="showFormContent" :formLoading.sync="disabled" :defId="defId" :proInstId="instId" myReadType="myReadType" ref="formContent" :copeInstId="copeInstId" class="flow_form_content"/>
      </el-card>
    </el-main>
    <!-- 选择路径跳转 -->
    <TaskSelectDestination
      ref="taskSelectDestination"
      taskId
      :defId="defId"
      :instId="instId"
      :leaderId="leaderId"
    />
    <!-- 流程图 -->
    <TaskImage ref="taskImage" :defId="defId" />
  </el-container>
</template>

<script>
import TaskImage from "@/components/flow/task/taskImage.vue";
import req from "@/request.js";
import {mapState} from "vuex";
import FormContent from "@/components/flow/formContent.vue";
import TaskSelectDestination from "@/components/flow/task/taskSelectDestination.vue";
import utils from "@/utils.js";
import {Base64} from "js-base64";

export default {
  name: "start",
  components: {
    FormContent,
    TaskSelectDestination,
    TaskImage
  },
  props: ["defId", "instId", "leaderId","copeInstId"],
  data() {
    return {
      btn_region_w:"100%",
      disabled: false,
      nodeDef: {},
      flowId: "",
      isShowStartBtn: true,
      isMyRequest: false,
      defName:"",
      saveSuccess:true,
      showFormContent: true,
      lastTime: new Date().getTime(), // 最后一次点击的时间
      currentTime: new Date().getTime(), //当前时间
      overTime: 30 * 60 * 1000, //默认超时时间(30分钟)
    };
  },
  computed: mapState({
    curOrgPost: state => state.user.postCharge
  }),
  mounted() {
    let _this = this;
    //如果该字段的校验受另一个字段影响。则监听另一个字段控件发布的值改变事件
    this.$root.$on("startFlowBtnChange", function(value) {
      _this.isShowStartBtn = value;
    });
    window.jQuery("#app").find(".el-header").first().hide();//20220930
    window.jQuery("#app").find("#hymenu").css("width","0px;");
    window.jQuery("#app").find("#hycontent").css({"width":"100%","height":"100%"});
    //this.$root.$children[0].$children[0].$children[1].$el.style.display = "none";
    //改变操作按钮栏的宽度
     this.$root.$on("formLoading", function(value) {
       _this.disabled = value;
       setTimeout(()=>{
        _this.$set(_this,"btn_region_w",document.getElementsByClassName("start-card")[0].offsetWidth+"px");
      },1000)
    });
  },
  methods: {
    checkTime() {//超时未操作自动保存
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastTime > this.overTime) {//超时未操作自动保存
        if (sessionStorage.getItem("currentUser")) {
          this.lastTime = new Date().getTime();//更新最后操作时间 防止取到第一次保存后的时间
          // 保存
          this.saveDraft();
        }
      }
    },
    //流程图
    taskImage() {
      this.$refs.taskImage.handleOpen(); //父组件调用子组件方法
    },
    // 准备数据
    handleData(formDataStr) {
      let data = { defId: this.defId };
      if (formDataStr) {
        // URL表单
        if (formDataStr.constructor == Object) {
          data.formType = "frame";
          if (formDataStr.businessKey) {
            data.businessKey = formDataStr.businessKey;
          }
          if (formDataStr.sysCode) {
            data.sysCode = formDataStr.sysCode;
          }
          if (formDataStr.vars) {
            data.vars = formDataStr.vars;
          }
        } else if (formDataStr.constructor == String) {
          data.data = Base64.encode(formDataStr);
          data.formType = "inner";
        }
      }
      data.supportMobile = 0;
      if (this.instId) {
        data.proInstId = this.instId;
      }
      if (this.curOrgPost && this.curOrgPost.org) {
        data.startOrgId = this.curOrgPost.org.id;
      }
      if (window.urgentStateValue) {
        data.urgentStateValue = window.urgentStateValue;
      }
      if (this.leaderId && this.leaderId != 0) {
        data.agentLeaderId = this.leaderId;
      }
      return data;
    },
    //启动
    start() {
      this.btnAlias = "startFlow";
      //获取VUE表单实例(判断是否是在线表单)
      if (document.getElementsByName("online-form")[0]) {
        let tables = document.getElementsByName("online-form")[0].__vue__
          .permission.table; //获取子表权限
        let boData = document.getElementsByName("online-form")[0].__vue__.data; //获取表单bo对象
        let zData = {};
        for (let k in boData) {
          zData = boData[k];
        }
        for (let key in tables) {
          if (
            (tables[key].required == true || tables[key].required == "true") &&
                  zData["sub_" + key].length == 0
          ) {
            this.$message({ message: "子表必填一条记录", type: "warning" });
            return;
          }
        }
      }
      utils
        .getOnlineFormData(true)
        .then(formDataStr => {
          let scriptResult = this.runBeforeScript();
          if(scriptResult === false){
            return ;
          }
          if (
            !this.nodeDef.localProperties.jumpType &&
            !this.nodeDef.localProperties.choiceExcutor
          ) {
            this.processStart(formDataStr);
          } else {

            this.$store
              .dispatch("storeProcess/getAfterJumpNodes", {
                taskId: "",
                data: Base64.encode(formDataStr),
                defId: this.defId || "",
                instId: this.instId || ""
              })
              .then(data => {
                if (
                  data.afterNodes.length == 0 ||
                  (data.afterNodes.length == 1 &&
                    data.afterNodes[0].excutorList != undefined &&
                    data.afterNodes[0].excutorList.length == 1)
                ) {
                  this.processStart(formDataStr);
                } else {
                  let formData = {};
                  if (formDataStr.constructor == Object) {
                    formData = formDataStr;
                    formData.data = "";
                  } else if (formDataStr.constructor == String) {
                    formData.data = Base64.encode(formDataStr);
                  }
                  this.$refs.taskSelectDestination.showDailog(formData, "", ""); //父组件调用子组件方法
                }
              });
          }
        })
        .catch(reason =>
          utils
            .handleGetFormDataReject(reason, true)
            .then(() => this.processStart())
        );
    },
    //流程发起
    processStart(formDataStr) {
      let formKey= this.$refs.formContent.formKey;
      let data = this.handleData(formDataStr);
      data.formKey=formKey;
      this.disabled = true;
      this.$store
        .dispatch("storeProcess/start", data)
        .then(row => {
          this.$store.dispatch("storeProcess/getInstanceByInstId", row.instId).then(insts => {
            // if(insts.status!="end"){
            //   this.$router.push("/inst/" + row.instId + "/request");
            // }else{
            //   this.$router.push("/instRead/" + row.instId + "/myRequest");
            // }
            if(row.instId){
              this.handleAfterStart(row.instId);
            }
            this.windowClose();
          });
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    handleAfterStart(instId){
      //此方法具体实现由表单JS代理
    },
    //保存
    saveDraft() {
      this.btnAlias = "saveDraft";
      this.disabled = true;
      let scriptResult = this.runBeforeScript();
      let formKey = this.$refs.formContent.formKey;
      this.disabled = true;
      const this_ = this;
      utils .getOnlineFormData(false).then((formDataStr) => {
          utils.closeAllNotification();
          let data = this_.handleData(formDataStr);
          data.formKey = formKey;
          if (sessionStorage.getItem("formImportTempJson")) {
            data.updateSubTableJson = sessionStorage.getItem(
              "formImportTempJson"
            );
          }

          this_.$store
            .dispatch("storeProcess/saveDraft", data)
            .then((row) => {
              debugger;
              if (row.curBoPkVal) {
                sessionStorage.setItem("formImportTempRefId", row.curBoPkVal);
              }
              sessionStorage.removeItem("formImportTempJson");
              if(row.instId){
                this_.handlerAfterSave(row.instId);
              }
              this_.instId=row.instId;
              //保存完成后,需要重新加载bo数据,不然第二次保存的时候会因为版本号不同而导致保存失败
              this_.$router.push("/start/" + this_.defId + "/" + this_.instId);
              setTimeout(function(){
                location.reload();
              },100)
            })
            .catch((r) => {
              this.disabled = false;
              this_.saveSuccess = false;
            })
            /*.finally((param) => { //保存完成后,需要重新加载bo数据,不然第二次保存的时候会因为版本号不同而导致保存失败
              this_.$router.push("/start/" + this_.defId + "/" + this_.instId);
              setTimeout(function(){
                location.reload();
              },100)
            });*/
        })
        .catch((reason) => {
          this.disabled = false;
          utils.handleGetFormDataReject(reason);
        });
    },
    handlerAfterSave(instId){
      //此方法具体实现由表单JS代理
    },
    runBeforeScript(){
      let _this = this;
      let item = utils.indexOfList(
              _this.$refs.formContent.buttons,
              'alias',
              _this.btnAlias
      );
      return _this.tempScript(item.beforeScript);
    },
    tempScript(script){
      let _this = this.$refs.formContent;
      let _req = req;
      let boData = this.$refs.formContent.data;
      let tempScript =
              "var tempFunction = function(_req,data,_this){" + script + "};";
      let result = eval(tempScript + "tempFunction(_req,boData,_this)");
      if(result && result.then && typeof result.then == "function"){
        return result;
      }
      if(result === false) return false;
      return true;
    },
    //返回
    back() {
      /*if (this.isMyRequest) {
        this.$router.push("/v-flow/v-request");
      } else {
        if (JSON.stringify(this.$route.query) == "{}") {
          this.$router.go(-1);
        } else {
          this.$router.push("/home");
        }
      }*/
      window.close();
    },
    windowClose(){
      if(window.ch){
        //浏览器的两个选项卡之间通讯 新窗口发送消息
        window.ch.postMessage("some data");
      }
      window.close();
    },
    deleteBtm(){
      this.$confirm("删除后，单据无法恢复，请确认是否继续删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "继续删除",
        type: "warning",
        closeOnClickModal: false,
        }).then(()=>{
          this.$store.dispatch("storeProcess/removeDraftById", this.instId).then(() => {
          setTimeout(()=>{
            window.close()
          },2000)
        });
      }) 
    }
  },
  created() {
    //取发起节点的属性用于判断是否可以选择路径跳转
    window.agentLeaderId = this.leaderId;
    this.$store
      .dispatch("storeProcess/getCurNodeProperties", {
        defId: this.defId || "",
        instId: this.instId || "",
        taskId: ""
      })
      .then(NodeDef => {
        this.nodeDef = NodeDef;
      });
    //获取流程信息
    req
    .get(window.context.bpmModel +
      "/flow/def/v1/defGet?defId=" +
      this.defId
      )
      .then(res=>{
        this.defName = res.data.name;
        debugger;
      })
    //定时触发判断是否未点击
    window.setInterval(this.checkTime, 50000);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.el-main {
  padding: 0;
}

.el-header {
  padding: 0;
  height: 36px !important;
}

.top-subject-col > h3 {
  text-align: center;
  color: #141414;
  font-size:16px

}

.top-btns-col {
  padding-right: 6px;
  height: 48px;
  line-height: 48px;
  text-align: right;
}

.top-btns-col > button {
  color: #666;
}

.top-btns-col > button /deep/ span {
  margin-left: 3px;
}

.top-btns-col > button:hover {
  color: $--theme-color;
}

.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.start-card {
  background: #fff;
  /deep/.el-card__body{

    padding: 6px 20px;
  }
}
.flow_form_content{
  /deep/ .approve_content{
    padding:0;
  }
  /deep/.form-container-not{
    margin:0 0 10px 0;
  }
  /deep/.el-form-item__error{
    display: none;
  }
}
</style>
